import React from 'react'
import AddLocation from '@material-ui/icons/AddLocation'

export default function AddLocationIcon() {

    return (
        <AddLocation />
    )
}
